export default __webpack_public_path__ + "static/media/beginner-mark.b31a22b4.svg";